<template>
  <ElDialog name="envelope-add-party-modal"
    :visible="show"
    v-on="$listeners"
    v-loading="loading"
    :title="$t('envelope.party.addParty')"
    append-to-body
  >
    <div>
      <VForm :onSubmit="validateForm" data-vv-scope="envelope-party" ref="form">
        <div slot="row">
          <VGrid>
            <div slot="gridItem" type="6">
              <b>{{ $t('envelope.party.partyTitle') }}</b>
              <VInput
                type="text"
                placeholder="e.g. Finance"
                v-validate="'required'"
                data-vv-name="title"
                data-vv-as="title"
                v-model="party.title"
                data-ec="add_envelope_party_modal"
                data-et="party_title_input"
                data-vv-scope="envelope-party"
                :class="{ 'a-input--error': errors.has('envelope-party.title') }"
                data-hj-suppress />
              <VMessage
                type="error"
                subtype="basic"
                v-show="errors.has('envelope-party.title')">
                <template v-slot:icon>
                  <XMarkIcon />
                </template>
                <template v-slot:text>
                  {{ errors.first('envelope-party.title') }}
                </template>
              </VMessage>
            </div>
            <div slot="gridItem" type="6">
              <b>{{ $t('envelope.party.partyEmail') }}</b>
              <VInput
                type="text"
                placeholder="e.g. john@doe.com"
                v-validate="'required|isTrimmedEmail'"
                data-vv-name="email"
                data-vv-as="email"
                v-model.trim="party.email"
                data-ec="add_envelope_party_modal"
                data-et="party_email_input"
                data-vv-scope="envelope-party"
                :class="{ 'a-input--error': errors.has('envelope-party.email') }"
                data-hj-suppress
              />
              <VMessage
                type="error"
                subtype="basic"
                v-show="errors.has('party.email')">
                <template v-slot:icon>
                  <XMarkIcon />
                </template>
                <template v-slot:text>
                  {{ errors.first('party.email') }}
                </template>
              </VMessage>
            </div>
            <div slot="gridItem" type="6">
              <b>{{ $t('envelope.party.copyOnly') }}</b>
              <VCheckbox
                type="checkbox"
                subtype="toggle"
                size="small"
                :checked="false"
                data-ec="add_envelope_party_modal"
                data-et="receives_copy_only_checkbox"
                v-model="party.receivesCopyOnly"
              />
            </div>
          </VGrid>
        </div>
        <div slot="formButtons">
          <VButton
            type="success"
            class="float-right"
            subtype="submit"
            href="#"
            data-ec="add_envelope_party_modal"
            data-et="add_party_button">
            <CheckIcon />
            <span>{{ $t('envelope.party.addParty') }}</span>
          </VButton>
        </div>
      </VForm>
    </div>
  </ElDialog>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VCheckbox from '@/components/deprecated/atoms/Checkbox.vue';
import VInput from '@/components/deprecated/atoms/Input.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import { CheckIcon, XMarkIcon } from '@/components/icons/fontIcons';

export default {
  name: 'AddEnvelopePartyModal',
  inject: {
    $validator: '$validator',
  },
  components: {
    VButton,
    VCheckbox,
    VInput,
    VMessage,
    VForm,
    VGrid,
    CheckIcon,
    XMarkIcon,
  },
  props: {
    fingerprint: String,
    show: Boolean,
  },
  data() {
    return {
      loading: false,
      party: {
        title: '',
        email: '',
        receivesCopyOnly: false,
      },
    };
  },
  methods: {
    reset() {
      this.party = {
        title: '',
        email: '',
        receivesCopyOnly: false,
      };
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then((validated) => {
        if (validated) {
          this.loading = true;
          const parties = [this.party];
          this.$store.dispatch('envelopes/ADD_PARTIES', { parties, fingerprint: this.fingerprint, isViewing: false })
            .then(() => {
              this.reset();
              this.$emit('close');
            }).finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>
